import { BookOpen, ExternalLink } from "lucide-react";
import { FURTHER_READING } from "@/data/furtherReading";
import { useReading } from "@/context/ContentContext";

// Reusable "Read more / further reading" block shown on each simulator's
// final/result screen. Renders a curated list of external resources.
export const FurtherReading = ({ topic, className = "" }) => {
  const section = useReading(topic, FURTHER_READING[topic]);
  if (!section) return null;

  const links = Array.isArray(section.links) ? section.links : [];

  return (
    <div
      className={`rounded-xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}
      data-testid="further-reading"
    >
      <div className="flex items-center gap-2 mb-1">
        <BookOpen className="w-4 h-4 text-[#0047AB]" />
        <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wider">
          Read more · further reading
        </h3>
      </div>
      <p className="text-xs text-slate-500 mb-3 leading-relaxed">{section.blurb}</p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {links.map((l, i) => (
          <li key={l.href || i}>
            <a
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`reading-link-${topic}-${i}`}
              className="group flex items-start gap-2 h-full rounded-md border border-slate-200 px-3 py-2.5 hover:border-[#0047AB] hover:bg-[#0047AB]/5 transition-colors"
            >
              <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-[#0047AB] mt-0.5 shrink-0 transition-colors" />
              <span className="min-w-0">
                <span className="block text-[13px] font-medium text-slate-800 group-hover:text-[#0047AB] leading-snug transition-colors">
                  {l.label}
                </span>
                <span className="text-[11px] text-slate-400">{l.source}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[10px] text-slate-400 leading-relaxed">
        Links open in a new tab. Resources are pitched at veterinary-nurse standard —
        always defer to current guidelines and your clinic&apos;s protocols.
      </p>
    </div>
  );
};
